/* eslint-disable no-nested-ternary */
import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Box, TextHeading, TextBody, Link as MuiLink } from '@ally/metronome-ui';
import { space } from 'styled-system';
import { WireRequestedDescription, WireReviewingDescription, WireNeedsAttentionDescription, WireProcessingDescription, WireCanceledDescription, WireSentDescription, WireContactUsDescription, } from './StatusModalWireData';
import { getCheckShippedDescription } from './StatusModalCheckData';
import { AchProcessingDescription, AchDeliveredDescription, } from './StatusModalAchData';
import { DebitActivatedDescription, DebitDelayedDescription, DebitDeliveredDescription, DebitFailedDescription, DebitNeedsAttentionDescription, DebitOrderedDescription, DebitShippedDescription, } from './StatusModalDebitData';
const StyledTextHeading = styled(TextHeading)(space);
function getHeading(event) {
    const { activityName, eventModelData, statuses } = event;
    const currentStatus = statuses[0].status;
    const { isFunded } = eventModelData;
    const isAch = activityName === 'ACHTransfer';
    switch (currentStatus) {
        case 'Ordered':
            return isFunded ? 'Ordered' : 'Needs attention';
        case 'Confirmed':
            return 'Ordered';
        case 'InProcess':
            return isAch ? 'Processing' : 'Ordered';
        case 'VerificationRequired':
            return 'Needs attention';
        case 'Completed':
        case 'Posted':
            return 'Delivered';
        case 'Delayed':
            return 'Delivery delayed';
        case 'DeliveryFailed':
            return 'Action required';
        default:
            return currentStatus;
    }
}
function getCheckDescription(statuses) {
    switch (statuses[0].status) {
        case 'Shipped':
            return getCheckShippedDescription(statuses);
        default:
            return (React.createElement(TextBody, { tag: "p", size: "sm" }, "We're printing your checks and preparing them for shipping."));
    }
}
function getWireDescription(statuses) {
    switch (statuses[0].status) {
        case 'Reviewing':
            return React.createElement(WireReviewingDescription, null);
        case 'VerificationRequired':
            return React.createElement(WireNeedsAttentionDescription, null);
        case 'Processing':
            return React.createElement(WireProcessingDescription, { statuses: statuses });
        case 'Canceled':
            return React.createElement(WireCanceledDescription, { statuses: statuses });
        case 'Sent':
            return React.createElement(WireSentDescription, null);
        default:
            return React.createElement(WireRequestedDescription, null);
    }
}
function getAchDescription(currentStatus) {
    switch (currentStatus) {
        case 'Completed':
        case 'Posted':
            return React.createElement(AchDeliveredDescription, null);
        default:
            return React.createElement(AchProcessingDescription, null);
    }
}
function getDebitDescription(event, setConfirmModal, confirmationTriggerRef, isDebitCardControlHidden) {
    const { eventModelData, statuses } = event;
    const { isFunded } = eventModelData;
    switch (statuses[0].status) {
        case 'Ordered':
            return isFunded ? (React.createElement(DebitOrderedDescription, null)) : (React.createElement(DebitNeedsAttentionDescription, null));
        case 'Shipped':
            return (React.createElement(DebitShippedDescription, { eventModelData: eventModelData, setConfirmModal: setConfirmModal, confirmationTriggerRef: confirmationTriggerRef }));
        case 'Delivered':
            return (React.createElement(DebitDeliveredDescription, { eventModelData: eventModelData, setConfirmModal: setConfirmModal, confirmationTriggerRef: confirmationTriggerRef }));
        case 'Delayed':
            return (React.createElement(DebitDelayedDescription, { eventModelData: eventModelData, setConfirmModal: setConfirmModal, confirmationTriggerRef: confirmationTriggerRef }));
        case 'Activated':
            return (React.createElement(DebitActivatedDescription, { isDebitCardControlHidden: isDebitCardControlHidden }));
        case 'DeliveryFailed':
            return (React.createElement(DebitFailedDescription, { eventModelData: eventModelData, setConfirmModal: setConfirmModal, confirmationTriggerRef: confirmationTriggerRef }));
        default:
            return React.createElement(React.Fragment, null);
    }
}
function getDescriptionType(event, setConfirmModal, confirmationTriggerRef, isDebitCardControlHidden) {
    const { activityName, statuses } = event;
    const currentStatus = statuses[0].status;
    switch (activityName) {
        case 'CheckOrder':
            return getCheckDescription(statuses);
        case 'DebitCardOrder':
            return getDebitDescription(event, setConfirmModal, confirmationTriggerRef, isDebitCardControlHidden);
        case 'ACHTransfer':
        case 'InternalTransfers':
            return getAchDescription(currentStatus);
        default:
            return getWireDescription(statuses);
    }
}
const StatusModalDescription = ({ event, isStandaloneModal, isWiresMigrationEnabled, setConfirmModal, confirmationTriggerRef, isDebitCardEnabled, isDebitCardControlHidden, }) => {
    const { contactUsFlag } = event.eventModelData;
    const showContactUs = isWiresMigrationEnabled && contactUsFlag;
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { borderBottom: "solid 1px", borderColor: "slate-2" },
            React.createElement(StyledTextHeading, { tag: "h2", size: "xs", my: "md" }, showContactUs ? 'Action required' : getHeading(event)),
            React.createElement(Box, { mb: "md", "data-testid": "modal-description" }, showContactUs ? (React.createElement(WireContactUsDescription, null)) : (getDescriptionType(event, setConfirmModal, confirmationTriggerRef, isDebitCardControlHidden))),
            !isDebitCardEnabled && isStandaloneModal && (React.createElement(Box, { mb: "md" },
                React.createElement(MuiLink, { text: "View all items" },
                    React.createElement(Link, { to: "/status-tracker" })))))));
};
export default StatusModalDescription;
//# sourceMappingURL=StatusModalDescription.js.map